import React from "react";
import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section className="relative h-[88vh] flex items-center justify-center text-center overflow-hidden">
      {/* background image */}
      <div className="absolute inset-0">
        {/* Changed to smoke-related background */}
        <img
          src="https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=2000&q=80"
          alt="smoke-background"
          className="w-full h-full object-cover brightness-50"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/50" />
        <img
          src="https://i.ibb.co/JcgHTrC/smoke.png"
          alt="smoke"
          className="absolute inset-0 w-full h-full object-cover smoke-overlay"
        />
      </div>

      <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.2 }} className="relative z-10 max-w-3xl px-6">
        <h1 className="text-5xl md:text-6xl font-extrabold text-white drop-shadow-lg">One Stop For All Smoking Essentials</h1>
        <p className="mt-4 text-gray-300">Premium grinders, glassware, trays and tasteful accessories — curated for connoisseurs.</p>

        <div className="mt-8 flex items-center justify-center gap-4">
          <button className="px-6 py-3 rounded-full bg-gradient-to-r from-[#00ffcc] to-[#ff007a] text-black font-semibold shadow-lg hover:scale-105 transition">Shop Now</button>
          <button className="px-5 py-3 rounded-full bg-gradient-to-r from-[#00ffcc] to-[#ff007a] text-black font-semibold shadow-lg hover:scale-105 transition">Chat AI</button>
        </div>
      </motion.div>
    </section>
  );
}
